
import { Routes } from '@angular/router';
import { NoContentComponent } from './shared/no-content.component';
import { UserRequiredGuard } from './core/guards/user-required.guard';

export const appRoutes: Routes = [
  {
    path: '',
    loadChildren: () => import('./public/public.module').then((m) => m.PublicModule)
  },
  {
    path: 'portal',
    loadChildren: () => import('./portal/portal.module').then((m) => m.PortalModule),
    canActivate: [UserRequiredGuard],
  },
  {
    path: '**',
    component: NoContentComponent
  },
];
